import FieldsGeneratorRaw from './../../FieldsGenerator'
export default {
  name: 'Collumns',
  mixins: [FieldsGeneratorRaw],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'not-mutable'
  },
  data () {
    return {
      colBody: this.R.clone(this.config.colBody)
    }
  },
  created () {
    this.changeMode()
    this.addVVScope()
  },
  methods: {
    async validate () {
      let vm = this
      this.config.colBody.forEach((ele, key) => {
        Object.keys(this.config.colBody[key]).forEach(element => {
          try {
            let obj = this.config.colBody[key][element]
            if(vm.$refs[`${key}${vm._uid}${obj['fieldName'] ? obj['fieldName'] : ''}${element}`][0].validate) {
              vm.$refs[`${key}${vm._uid}${obj['fieldName'] ? obj['fieldName'] : ''}${element}`][0].validate()
            }
          } catch (error) {
            console.log(error)
          }
        })
      })
    },
    changeMode () {
      if (this.$q.screen.xs && this.colBody.length >= 2 && this.config.leftRightMode) {
        let result = this._.values(this.colBody[0])
        for (let key = 1; key < this.colBody.length; key++) {
          let second = this._.values(this.colBody[key])
          result = result.reduce((arr, v, i) => {
            return (i + 1) % key === 0 && second[i] ? arr.concat(v, second[i]) : arr.concat(v)
          }, [])
          this.colBody = [this._.mapKeys({ ...result }, (value, key) => 'item-' + key)]
        }
      } else {
        this.colBody = this.config.colBody
      }
    },
    addVVScope () {
      for (let key in this.colBody) {
        for (let k in this.colBody[key]) {
          this.colBody[key][k].vvScope = this.config.vvScope
          if(this.config.readonly) {
            this.colBody[key][k].readonly = true
          }
          this.initDataForContainer(this.colBody[key][k])
        }
      }
    }
  },
  watch: {
    '$q.screen.xs' () {
      this.changeMode()
    },
    'config.colBody': {
      handler: function(newValue) {
        this.colBody = newValue
        this.addVVScope()
      },
      deep: true
    }
  }
}
